import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

const Tabbar = ({ tabs, currentTab, onTabChange }) => {
  const handleTabClick = (tab) => {
    onTabChange(tab);
  };

  return (
    <Nav tabs fill pills>
      {tabs.map((tab) => (
        <NavItem key={tab}>
          <NavLink
            className={classnames('tab-link', { 'active-tab': currentTab === tab })}
            // className={classnames({ active: currentTab === tab })}
            onClick={() => handleTabClick(tab)}
          >
            {tab.replace(/-/g, ' ').toUpperCase()}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default Tabbar;